export const PACKAGE_NAME = 'jiraRouterResourcesServicedeskProjectSummary';
export const TEAM_NAME = 'jsd-shield';
